<template>
  <div class="selected-filters clearfix">
    <span
      :class="'text-appearance selected-filter cursor-pointer filter-' + tag.id"
      v-for="tag in tagList"
      @click="removeTag(tag)"
    >
      {{ tag.name }} <span class="ml-1 text-muted">✕</span>
    </span>

    <span
      class="selected-filter reset-all cursor-pointer"
      v-if="tagList.length >= 2"
      @click="resetAllTags()"
    >
      {{ $translate("Ceres::Template.itemFilterReset") }}
      <span class="ml-1">✕</span>
    </span>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  props: {
    facetData: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  computed: mapState({
    tagList: (state) => state.itemList.selectedFacets,
  }),

  created() {
    if (!this.$store.state.itemList.facets?.length) {
      this.$store.commit("addFacets", this.facetData);
    }
  },

  methods: {
    removeTag(tag) {
      this.selectFacet({ facetValue: tag });
      this.loadItemList();
    },

    resetAllTags() {
      this.resetAllSelectedFacets();
      this.loadItemList();
    },

    ...mapMutations(["resetAllSelectedFacets"]),

    ...mapActions(["selectFacet", "loadItemList"]),
  },
};
</script>
